/*=========================================================================================
  File Name: module-agreement-getters.js
  Description: Agreement Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	LinkHistoryAgreement(state) {
		return state.LinkHistoryAgreement;
	},

	Agreement(state) {
		return state.Agreement;
	},

	ProductAgreement(state) {
		return state.ProductAgreement;
	}
};
